import type { Tenant, User, UserRole } from '@/type';

export enum LANG {
  KO = 'ko',
  EN = 'en',
  // CN = 'cn',
  JP = 'jp',
}

export const KEYS = {
  STORAGE_LANG: 'STORAGE_LANG',
  STORAGE_REDIRECT_URL: 'STORAGE_REDIRECT_URL',
  STORAGE_IDB_STORE_LIST: 'STORAGE_IDB_STORE_LIST',
} as const;

export const DEFAULT_REDIRECT_PATH = '/project';
export const DEFAULT_WORKER_REDIRECT_PATH = '/my-work';
export const GET_REDIRECT_PATH_BY_ROLE = (role: User['role']) =>
  role === 'Worker' ? DEFAULT_WORKER_REDIRECT_PATH : DEFAULT_REDIRECT_PATH;

export const ROLE_NON_ACCESS_ROUTES_MAPPER: {
  [K in UserRole]: (string | RegExp)[];
} = {
  Admin: [],
  SiteAdmin: [],
  Manager: [],
  Worker: [/^\/project$/, '/setting', '/user/group'],
  Guest: [/^\/project$/, '/setting', '/user/group'],
};

export const APP_API_URL = import.meta.env.VITE_APP_API_URL;

export const PRICE_PLAN_PER_TENANT: {
  [key in Tenant['tier']]: {
    autoLableing: number; // frame
    dataStorage: number; //GB
    member: {
      admin: number;
      member: number;
    };
    ec2: string;
    maxUploadSize: number; // MB
  };
} = {
  freetier: {
    autoLableing: 100,
    dataStorage: 10,
    member: {
      admin: 1,
      member: 1,
    },
    ec2: 'g4dn.xlarge',
    maxUploadSize: 5,
  },
  standard: {
    autoLableing: 2000,
    dataStorage: 150,
    member: {
      admin: 1,
      member: 1,
    },
    ec2: 'g4dn.2xlarge',
    maxUploadSize: 5,
  },
};
